import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

import { ref, getCurrentInstance, withDefaults, onMounted, watch } from 'vue';

	interface main {
		id ?: string | number,
		size ?: string,
		ValueKey ?: string,
		LabelKey ?: string,
		width ?: string | number,
		disabled ?: boolean,
		IsAuto ?: boolean,
	}
export default /*#__PURE__*/_defineComponent({
  __name: 'InOrderTypeSelect',
  props: {
    id: { default: "" },
    size: { default: "default" },
    ValueKey: { default: "value" },
    LabelKey: { default: "label" },
    width: { default: "100%" },
    disabled: { type: Boolean, default: false },
    IsAuto: { type: Boolean, default: false }
  },
  emits: ["update:id", "change", "clear"],
  setup(__props: any, { emit: __emit }) {

	;

	const props = __props;

	const { proxy } = getCurrentInstance() as any;
	const emits = __emit;
	const TypeId = ref<any>("");
	const TypeList = ref<any>([]);
	const loading = ref(false);
	const placeholder = ref("请选择单据范围")

	watch(() => props.id, (n : any) => {
		TypeId.value = n;
	});

	onMounted(() => {
		TypeId.value = props.id;
		if (proxy.$store.state.IsRefreshInOrderType) {
			GetData();
		} else {
			if (proxy.$store.state.InOrderTypeList.length > 0) {
				TypeList.value = proxy.$store.state.InOrderTypeList;
				emits("update:id", TypeList.value[0].value);
			} else {
				GetData();
			}
		}
	});

	const TypeChange = (data : any) => {
		emits("update:id", data);
		emits("change", data);
	};
	const TypeClear = () => {
		emits("clear");
	};
	const SelectFocus = () => {
		if (proxy.$store.state.IsRefreshInOrderType) {
			GetData();
		} else {
			if (proxy.$store.state.InOrderTypeList.length > 0) {
				TypeList.value = proxy.$store.state.InOrderTypeList;
				emits("update:id", TypeList.value[0].value);
			} else {
				GetData();
			}
		}
	};
	const GetData = () => {
		loading.value = true;
		proxy.$api.tokenRequest({
			url: "/admin/common/orderType",
			method: "GET",
			success: (res : any) => {
				loading.value = false;
				TypeList.value = res.data.in;
				TypeId.value = res.data.in[0].value;
				emits("update:id", res.data.in[0].value);
				proxy.$store.commit("GetAllList", {
					type: 21,
					data: res.data.in,
				});
			},
			fail: () => {
				loading.value = false;
			}
		});
	}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createBlock(_component_el_select, {
    "remote-show-suffix": "",
    clearable: "",
    filterable: "",
    style: _normalizeStyle({'width': `${_ctx.width}`}),
    disabled: _ctx.disabled,
    size: _ctx.size,
    modelValue: TypeId.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((TypeId).value = $event)),
    loading: loading.value,
    onFocus: SelectFocus,
    placeholder: placeholder.value,
    onChange: TypeChange,
    onClear: TypeClear
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(TypeList.value, (v) => {
        return (_openBlock(), _createBlock(_component_el_option, {
          key: v[_ctx.ValueKey],
          label: v[_ctx.LabelKey],
          value: v[_ctx.ValueKey]
        }, null, 8, ["label", "value"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["style", "disabled", "size", "modelValue", "loading", "placeholder"]))
}
}

})